import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import footerLogo from '../../../assets/images/footer-logo.png';
import facebookIcon from '../../../assets/icons/facebook.svg';
import arrow from '../../../assets/icons/arrow.svg';
import instagramIcon from '../../../assets/icons/instagram.svg';
import languageIcon from '../../../assets/icons/figma.svg';
import './footer.css';

export const Footer = () => {
  return (
    <footer className="footer">
      <Container className="footer__container">
        <Row className="footer__top g-4">

          {/* Col 1 — Logo + description + social */}
          <Col xs={12} md={6} lg={4}>
            <img src={footerLogo} alt="Bizaario Care" className="footer__logo" />
            <p className="footer__desc">
              High level experience in web design and development knowledge, producing quality work.
            </p>
            <p className="footer__follow">Follow us</p>
            <div className="footer__socials">
              <a href="#"  aria-label="Facebook">
                <img src={facebookIcon} alt="Facebook" />
              </a>
               <a href="#" aria-label="Instagram">
                <img src={arrow} alt="Instagram" />
              </a>
              <a href="#" aria-label="Instagram">
                <img src={instagramIcon} alt="Instagram" />
              </a>
              <a href="#" aria-label="Website">
                <img src={languageIcon} alt="Website" />
              </a>
            </div>
          </Col>

          {/* Col 2 — Contact info */}
          <Col xs={12} md={6} lg={3}>
            <div className="footer__contact-item">
              {/* Location pin */}
              <svg className="footer__contact-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
              </svg>
              <p className="footer__contact-text">
                A-64 Sector 63, Noida
                Uttar Pradesh, 201301
                India
              </p>
            </div>
            <div className="footer__contact-item">
              {/* Email */}
              <svg className="footer__contact-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
              </svg>
              <p className="footer__contact-text">rjvijs42@gmail.com</p>
            </div>
            <div className="footer__contact-item">
              {/* Phone */}
              <svg className="footer__contact-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.82a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              <p className="footer__contact-text">+91 5252525252</p>
            </div>
          </Col>

          {/* Col 3 — Company links */}
          <Col xs={6} lg={2}>
            <h6 className="footer__col-title">Company</h6>
            <ul className="footer__links">
              <li><a href="#" className="footer__link">About Us</a></li>
              <li><a href="#" className="footer__link">FAQs</a></li>
              <li><Link to="/contact" className="footer__link">Contact Us</Link></li>
            </ul>
          </Col>

          {/* Col 4 — Use Cases links */}
          <Col xs={6} lg={3}>
            <h6 className="footer__col-title">Use Cases</h6>
            <ul className="footer__links">
              <li><a href="#" className="footer__link">Privacy Policy</a></li>
              <li><a href="#" className="footer__link">Terms of Use</a></li>
              <li><a href="#" className="footer__link">Legal</a></li>
            </ul>
          </Col>

        </Row>
      </Container>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <p className="footer__bottom-text">©2021 BIZAARIO CONNECT All Rights Reserved</p>
      </div>
    </footer>
  );
};
